import "./App.css";
import { Link, useParams, useSearchParams } from "react-router-dom";
import {Accordion} from './AccordionComponent/Accordion.jsx';
import {ProjectList} from './ProjectListComponent/ProjectList.jsx';
import {ProjectSummary} from './SummaryComponent/Summary.jsx';

// Initialize default sortType
let sortType = "Organization";

// Initialize global variables for links to external pages
const illustrativeURL = "https://data.marc.org/assets/ckc/CKC2050IllustrativeProjectsList.pdf";
const constrainedURL = "https://data.marc.org/assets/ckc/CKC2050ConstrainedProjectsList.pdf";
const mapURL = "https://marc-gis.maps.arcgis.com/apps/mapviewer/index.html?webmap=85c5b97c70ac47b7863851f46af4550a";
const bannerImage = "https://data.marc.org/assets/CKC/CKC2050Logo.png";



// Set up navigation links and Accordion display of projects by organization
export function ViewByOrganization() {
  sortType = "Organization";
  return (
    <div className="listcontainer">
      <img src={bannerImage}></img>
      <div className="instructions">Please note: The map of projects does not have every project included - based on the nature of the project, such as operational improvements, 
        some projects do not have a specific location.
      </div>
      <nav>
        <div className="nav-row">
        <Link to="/organization"><button type="button" className="button-current-link">View by Organization</button></Link>&nbsp;&nbsp;
        <Link to="/system"><button type="button" className="button-link">View by System</button></Link>&nbsp;&nbsp;
        <Link to="/projectmode"><button type="button" className="button-link">View by Primary Project Mode</button></Link>&nbsp;&nbsp;
        <Link to="/comments"><button type="button" className="button-link">View Projects with Comments</button></Link>&nbsp;&nbsp;<br />
        </div>
        <div className="nav-row">
        <Link to={mapURL} target="_blank" rel="noopener noreferrer"><button type="button" className="button-link">View Projects on Map</button></Link>&nbsp;&nbsp;
        <Link to={illustrativeURL} target="_blank" rel="noopener noreferrer"><button type="button" className="button-link">Illustrative Projects Printable Summary</button></Link>&nbsp;&nbsp;
        <Link to={constrainedURL} target="_blank" rel="noopener norefferer"><button type="button" className="button-link">Constrained Projects Printable Summary</button></Link>
        </div>
      </nav>
      <br />
      <div><Accordion sortbyGroup={sortType} /></div>
    </div>
  );
}

// Set up navigation links and Accordion display of projects by system
export function ViewBySystem() {
  sortType = "System";
  return (
    <div className="listcontainer">
      <img src={bannerImage}></img>
      <div className="instructions">Please note: The map of projects does not have every project included - based on the nature of the project, such as operational improvements, 
        some projects do not have a specific location.
      </div>
      <nav>
      <div className="nav-row">
        <Link to="/organization"><button type="button" className="button-link">View by Organization</button></Link>&nbsp;&nbsp;
        <Link to="/system"><button type="button" className="button-current-link">View by System</button></Link>&nbsp;&nbsp;
        <Link to="/projectmode"><button type="button" className="button-link">View by Primary Project Mode</button></Link>&nbsp;&nbsp;
        <Link to="/comments"><button type="button" className="button-link">View Projects with Comments</button></Link>&nbsp;&nbsp;<br />
      </div>
      <div className="nav-row">
        <Link to={mapURL} target="_blank" rel="noopener noreferrer"><button type="button" className="button-link">View Projects on Map</button></Link>&nbsp;&nbsp;
        <Link to={illustrativeURL} target="_blank" rel="noopener noreferrer"><button type="button" className="button-link">Illustrative Projects Printable Summary</button></Link>&nbsp;&nbsp;
        <Link to={constrainedURL} target="_blank" rel="noopener norefferer"><button type="button" className="button-link">Constrained Projects Printable Summary</button></Link>
      </div>
      </nav>
      <br />
      <div><Accordion sortbyGroup={sortType}/></div>
    </div>
  );
}

// Set up navigation links and Accordion display of projects by mode
export function ViewByProjectMode() {
  sortType = "Mode";
  return (
    <div className="listcontainer">
      <img src={bannerImage}></img>
      <div className="instructions">Please note: The map of projects does not have every project included - based on the nature of the project, such as operational improvements, 
        some projects do not have a specific location.
      </div>
      <nav>
      <div className="nav-row">
        <Link to="/organization"><button type="button" className="button-link">View by Organization</button></Link>&nbsp;&nbsp;
        <Link to="/system"><button type="button" className="button-link">View by System</button></Link>&nbsp;&nbsp;
        <Link to="/projectmode"><button type="button" className="button-current-link">View by Primary Project Mode</button></Link>&nbsp;&nbsp;
        <Link to="/comments"><button type="button" className="button-link">View Projects with Comments</button></Link>&nbsp;&nbsp;<br />
      </div>
      <div className="nav-row">
        <Link to={mapURL} target="_blank" rel="noopener noreferrer"><button type="button" className="button-link">View Projects on Map</button></Link>&nbsp;&nbsp;
        <Link to={illustrativeURL} target="_blank" rel="noopener noreferrer"><button type="button" className="button-link">Illustrative Projects Printable Summary</button></Link>&nbsp;&nbsp;
        <Link to={constrainedURL} target="_blank" rel="noopener norefferer"><button type="button" className="button-link">Constrained Projects Printable Summary</button></Link>
      </div>
      </nav>
      <br />
      <div><Accordion sortbyGroup={sortType} /></div>
    </div>
  );
}

// Set up navigation links and display of projects by project name
export function ViewByProjectComments() {
  sortType = "";
  return (
    <div className="listcontainer">
      <img src={bannerImage}></img>
      <div className="instructions">Please note: The map of projects does not have every project included - based on the nature of the project, such as operational improvements, 
        some projects do not have a specific location.
      </div>
      <nav>
      <div className="nav-row">
        <Link to="/organization"><button type="button" className="button-link">View by Organization</button></Link>&nbsp;&nbsp;
        <Link to="/system"><button type="button" className="button-link">View by System</button></Link>&nbsp;&nbsp;
        <Link to="/projectmode"><button type="button" className="button-link">View by Primary Project Mode</button></Link>&nbsp;&nbsp;
        <Link to="/comments"><button type="button" className="button-current-link">View Projects with Comments</button></Link>&nbsp;&nbsp;<br />
      </div>
      <div className="nav-row">
        <Link to={mapURL} target="_blank" rel="noopener noreferrer"><button type="button" className="button-link">View Projects on Map</button></Link>&nbsp;&nbsp;
        <Link to={illustrativeURL} target="_blank" rel="noopener noreferrer"><button type="button" className="button-link">Illustrative Projects rintable Summary</button></Link>&nbsp;&nbsp;
        <Link to={constrainedURL} target="_blank" rel="noopener norefferer"><button type="button" className="button-link">Constrained Projects Printable Summary</button></Link>
      </div>
      </nav>
      <br />
      <div><ProjectList /></div>
    </div>
  );
}

// Set up navigation links and Accordion display of projects by organization
export function ViewProjectMap() {
  return (
    <div className="listcontainer">
      <img src={bannerImage}></img>
      <div className="instructions">Please note: The map of projects does not have every project included - based on the nature of the project, such as operational improvements, 
        some projects do not have a specific location.
      </div>
      <nav>
      <div className="nav-row">
        <Link to="/organization">View by Organization</Link>&nbsp;&nbsp;
        <Link to="/system">View by System</Link>&nbsp;&nbsp;
        <Link to="/projectmode">View by Primary Project Mode</Link>&nbsp;&nbsp;
        <Link to="/comments">View Projects with Comments</Link>&nbsp;&nbsp;<br />
      </div>
      <div className="nav-row">
        <Link to={mapURL} target="_blank" rel="noopener noreferrer">View Projects on Map</Link>&nbsp;&nbsp;
        <Link to={illustrativeURL} target="_blank" rel="noopener noreferrer">Illustrative Projects Printable Summary</Link>&nbsp;&nbsp;
        <Link to={constrainedURL} target="_blank" rel="noopener norefferer">Constrained Projects Printable Summary</Link>
      </div>
      </nav>
    </div>
  );
}

// Set up navigation links and Accordion display of projects by organization
export function ViewIllustrative() {
  return (
    <div className="listcontainer">
      <img src={bannerImage}></img>
      <div className="instructions">Please note: The map of projects does not have every project included - based on the nature of the project, such as operational improvements, 
        some projects do not have a specific location.
      </div>
      <nav>
      <div className="nav-row">
        <Link to="/organization">View by Organization</Link>&nbsp;&nbsp;
        <Link to="/system">View by System</Link>&nbsp;&nbsp;
        <Link to="/projectmode">View by Primary Project Mode</Link>&nbsp;&nbsp;
        <Link to="/comments">View Projects with Comments</Link>&nbsp;&nbsp;<br />
      </div>
      <div className="nav-row">
        <Link to={mapURL} target="_blank" rel="noopener noreferrer">View Projects on Map</Link>&nbsp;&nbsp;
        <Link to={illustrativeURL} target="_blank" rel="noopener noreferrer">Illustrative Projects Printable Summary</Link>&nbsp;&nbsp;
        <Link to={constrainedURL} target="_blank" rel="noopener norefferer">Constrained Projects Printable Summary</Link>
      </div>
      </nav>
    </div>
  );
}

// Set up navigation links and Accordion display of projects by organization
export function ViewConstrained() {
  return (
    <div className="listcontainer">
      <img src={bannerImage}></img>
      <div className="instructions">Please note: The map of projects does not have every project included - based on the nature of the project, such as operational improvements, 
        some projects do not have a specific location.
      </div>
      <nav>
      <div className="nav-row">
        <Link to="/organization">View by Organization</Link>&nbsp;&nbsp;
        <Link to="/system">View by System</Link>&nbsp;&nbsp;
        <Link to="/projectmode">View by Primary Project Mode</Link>&nbsp;&nbsp;
        <Link to="/comments">View Projects with Comments</Link>&nbsp;&nbsp;<br />
      </div>
      <div className="nav-row">
        <Link to={mapURL} target="_blank" rel="noopener noreferrer">View Projects on Map</Link>&nbsp;&nbsp;
        <Link to={constrainedURL} target="_blank" rel="noopener norefferer">Constrained Projects Printable Summary</Link>
        <Link to={illustrativeURL} target="_blank" rel="noopener noreferrer">Illustrative Projects Printable Summary</Link>&nbsp;&nbsp;
      </div>
      </nav>
    </div>
  );
}



export function App() {

  // check for URL params and set project number to session storage if present
  const[searchParams, setSearchParams] = useSearchParams();
  sessionStorage.setItem('ProjectNumber', searchParams.get("id"));
   if (sessionStorage.getItem('ProjectNumber') === 'null') { 
  return <div>
    <ViewByOrganization />
    </div>
  }
  else {
    return <div>
      <ProjectSummary />
    </div>
  }
}